import axiosClient from '../config/axiosConfig';

export const userlogin = (payload, token) => {
  return axiosClient('auth/user/login', payload, 'POST');
};

export const userSignup = (payload, token) => {
  return axiosClient('auth/user/signup', payload, 'POST');
};

export const VerifyEmail = (payload, token) => {
  return axiosClient('user/Verify-Email', payload, 'POST');
};

export const VerifyLink = (payload, token) => {
  return axiosClient('auth/user/Verify-Email-Link', payload, 'POST');
};

export const updateUserProfile = (payload, token) => {
  return axiosClient('user/update-user-profile', payload, 'POST', {
    Authorization: token,
  });
};

export const forgetPassword = (payload, token) => {
  return axiosClient('auth/forgetPassword', payload, 'POST');
};

export const changePassword = (payload, token) => {
  return axiosClient('auth/changePassword', payload, 'POST', {
    Authorization: token,
  });
};

export const getUsdtAddress = (payload, token) => {
  return axiosClient('preSale/get-usdt-address', payload, 'GET');
};

export const getInfiTokenPrice = (payload, token) => {
  return axiosClient('preSale/get-INFIPrice', payload, 'GET');
};

export const getInfiChartData = (payload, token) => {
  return axiosClient('user/infi-price-chart-user', payload, 'GET');
};

export const getInfiPoolBalancetData = (payload, token) => {
  return axiosClient('liquidity/get-sbsepfp-pool-balance', payload, 'GET');
};

export const getPresaleStatistics = (payload, token) => {
  return axiosClient('preSale/PresaleStatistics', payload, 'GET');
};
export const getTotalPurchased = (walletAddress) => {
  return axiosClient('preSale/get-infi-to-send/' + walletAddress, {}, 'GET');
};

export const buyTransactionHistory = (user_id, token) => {
  return axiosClient('user/buy-transaction-list/' + user_id, {}, 'GET', {
    Authorization: token,
  });
};

export const cdexTransactionHistory = (user_id, token) => {
  return axiosClient('user/cdex-transaction-list/' + user_id, {}, 'GET', {
    Authorization: token,
  });
};

export const stakingTransactionHistory = (user_id, token) => {
  return axiosClient('user/staking-transaction-list/' + user_id, {}, 'GET', {
    Authorization: token,
  });
};

// export const syncUser = async (payload, token) => {
//   const response = await fetch(`http://localhost:8000/users/syncUser`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       accessToken: payload,
//     }),
//   });
//   let xyz = await response.json();
//   console.log('aaaaa', xyz);
//   return xyz;
// };
